import { render, staticRenderFns } from "./ReviewLanding.vue?vue&type=template&id=2c07f6f2&scoped=true"
import script from "./ReviewLanding.vue?vue&type=script&lang=js"
export * from "./ReviewLanding.vue?vue&type=script&lang=js"
import style0 from "./ReviewLanding.vue?vue&type=style&index=0&id=2c07f6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07f6f2",
  null
  
)

export default component.exports